import http from './http';

const getWebsites = (value, page, unpaid, expert, custom, free, locked, owner, pageSize = 30) => {
  const base = `/website?admin=admin&page_size=${pageSize}&page_nbr=${page}&sort_field=created_at&sort_type=desc`;
  const q = value && value.length > 0 ? `&query=${encodeURIComponent(value)}` : '';
  const params =
    `&unpaid=${Boolean(unpaid)}&expert=${Boolean(expert)}&custom=${Boolean(custom)}` +
    `&free=${Boolean(free)}&locked=${Boolean(locked)}&owner=${owner || ''}`;
  return http.get(`${base}${q}${params}`);
};

const reinitialiser = (website) => http.del(`/website/${website}/wp_import/delete`);

const deleteCustom = (website) => http.del(`/website/${website}/cancel_plan`);

const lockQuota = (website) => http.post(`/website/${website}/quota/lock`);
const unlockQuota = (website) => http.post(`/website/${website}/quota/unlock`);

// Débloque / rebloque l'illimité IA Enterprise pour un site (super-admin global, endpoint B0_02).
const setAiAllowed = (website, allowed) => http.post(`/website/${website}/admin/ai-allowed`, { ai_allowed: allowed });

// Active / désactive la modération AUTONOME (auto-apply Enterprise, flag C5) d'un site (super-admin global, endpoint B4_01).
const setAiAutonomous = (website, enabled) => http.post(`/website/${website}/admin/ai-autonomous`, { enabled });

// Bascule le mode GraphDebate (forum | media) d'un site (super-admin global, endpoint B0_02).
const setGraphdebateMode = (website, mode) => http.post(`/website/${website}/admin/graphdebate-mode`, { mode });

// FCM: list subscribers for a website (owner/admin only)
const getFcmSubscribers = (websiteId) => {
  if (!websiteId) throw new Error('websiteId is required');
  return http.get(`/fcm/subscribers/website/${websiteId}`);
};

export default { getWebsites, reinitialiser, deleteCustom, lockQuota, unlockQuota, setAiAllowed, setAiAutonomous, setGraphdebateMode, getFcmSubscribers };
export { getWebsites, reinitialiser, deleteCustom, lockQuota, unlockQuota, setAiAllowed, setAiAutonomous, setGraphdebateMode, getFcmSubscribers };
